import { Col } from "antd";
import React, { useEffect, useRef, useState } from "react";
import ReactDOM from 'react-dom';
import { Route, withRouter } from "react-router-dom";
import close from "../../../assets/icons/close-circle.svg";
import { StepFlexRow } from "../../commonStyles";
import { CloseTag, Info2, InfoView, MobileHoverHeading, Mask } from "./components/styles";
import { ActiveIcon, ContactPara, ExchangeStep, FlowSteps, SnagHeader, SnagSection, StepBand, StepNumber } from "./styles";
import PropTypes from "prop-types";
import { recordError } from "../../../utils/commonUtil";

export const GenericStepper = ({ stepConfig = [], affixRef, history, hideSteps, disableSteppers, snagSection = false, flowName, grantAgreement, featureCode = '' }) => {
  const initialState = [];
  const isDesktop = window.innerWidth > 991.92;
  const path = history.location.pathname;

  //TODO: The below can be custom hook and part of utils
  const useDocumentClickChecker = (ref) => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        handleStepMouseLeave(event);
      }
    }
    useEffect(() => {
      if (isDesktop) return;
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    });
  }
  const wrapperRef = useRef(null);
  useDocumentClickChecker(wrapperRef);

  const useStickyStepper = (stepperRef) => {
    useEffect(() => {
      if (!isDesktop) return;
      let bottomHit = 600;
      if (affixRef && affixRef.current);
      let offsetHeight = 0;
      if(stepConfig.length > 3 || grantAgreement) {
        offsetHeight = 149;
      }
      bottomHit = document.getElementById('root').offsetHeight - affixRef.current.offsetHeight + offsetHeight + affixRef.current.offsetTop
      const handleScroll = (e) => {
        if (affixRef && affixRef.current && stepperRef && stepperRef.current) {
          const node = ReactDOM.findDOMNode(stepperRef.current);
          const stepsContainer = node.children[0];
          const { top, bottom } = node.getBoundingClientRect();
          if ((top - affixRef.current.offsetTop) <= 0) {
            stepsContainer.classList.add('sticky');
            if (bottom <= bottomHit) {
              stepsContainer.classList.add('stick-to-bottom');
            } else {
              stepsContainer.classList.remove('stick-to-bottom');
            }
          } else {
            stepsContainer.classList.remove('sticky');
            stepsContainer.classList.remove('stick-to-bottom');
          }
        }
      }
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    })
  }

  const stepperRef = useRef(null);
  useStickyStepper(stepperRef);

  stepConfig.forEach((config) => {
    initialState.push({ id: config.key, hovered: false, activateReverseAnimation: false, status: config.status ? config.status : 'wait' });
  });

  const [filled, setFilled] = useState([...initialState]);
  const [activeStep, setActiveStep] = useState(undefined);
  const [hoverKey, setHoverKey] = useState('');

  const generateTitleNode = (config, activeStep) => {
    const { status, hovered, activateReverseAnimation } = filled[config.key - 1];
    const toBeShown = isDesktop && hovered && status === 'finished';
    return (
      <>
        <StepBand active={(status === 'finished' || status === "process")} />
        <ActiveIcon
          raise={hovered}
          active={iconRender(hovered, status, config, activeStep)}
          type="caret-right"
        />
        {isDesktop && config.stepContent && generateHoverContent(config, toBeShown, activateReverseAnimation)}
        <StepNumber active={(status === 'finished' || status === "process")} currentActive={activeStep === config.key}>
          Step {config.key}
        </StepNumber>
      </>
    );
  }

  const iconRender = (hovered, status, config, activeStep) => {
    if(hoverKey && config.stepContent && status === 'finished') return (hovered && status === 'finished');
    else if(hoverKey && status === 'process') return (activeStep === hoverKey);
    else return (config && config.key === activeStep);
  }

  const generateDescriptionNode = (description) => (
    <>
      <span>{description}</span>
    </>
  );

  const handleStepMouseEnter = (e, configKey) => {
    try {
      const filledArray = [...filled];
      filledArray.forEach((step) => {
        const stepCopy = step;
        (stepCopy.id === configKey) && setHoverKey(stepCopy.id);
        stepCopy.hovered = (stepCopy.id === configKey);
        stepCopy.activateReverseAnimation = (stepCopy.id === configKey);
      });
      setFilled(filledArray);
    } catch (error) {
      recordError(error);
    }
  };

  const handleStepMouseLeave = (e) => {
    try {
      const filledArray = [...filled];
      filledArray.forEach((step) => {
        const stepCopy = step;
        stepCopy.hovered = false;
        setHoverKey('');
      });
      setFilled(filledArray);
      e.stopPropagation();
    } catch (error) {
      recordError(error);
    }
  };

  const setActiveStepNumber = () => {
    let activeStepNumber;
    const filledArray = [...filled];
    stepConfig.every((config, i) => {
      activeStepNumber = path === config.route ? config.key : undefined;
      if (config.subRoutes && !activeStepNumber) {
        config.subRoutes.every((subRoute) => {
          activeStepNumber = path === subRoute.path ? config.key : undefined;
          return !activeStepNumber;
        })
      }
      filledArray[i].hovered = false;
      if (!activeStepNumber)
        filledArray[i].status = 'finished';
      return !activeStepNumber;
    });

    for (let i = activeStepNumber; i < filledArray.length; i++) {
      let { status } = filledArray[i];
      status = status === 'finished' ? 'process' : 'wait';
      filledArray[i].status = status;
    }

    if (filledArray[activeStepNumber - 1]) filledArray[activeStepNumber - 1].status = 'process';
    setActiveStep(activeStepNumber);
  };

  useEffect(setActiveStepNumber, [path]);
  if (filled.length !== stepConfig.length) {
    setFilled([...initialState]);
    return <></>;
  }

  const generateContent = (config, index) => (
    <ExchangeStep
      data-test ="exchange-step-test"
      onMouseEnter={e => handleStepMouseEnter(e, config.key)}
      onMouseLeave={e => handleStepMouseLeave(e)}
      key={config.key}
      active={config && config.key === activeStep}
      title={generateTitleNode(config, activeStep)}
      description={generateDescriptionNode(config.description)}
      status={filled[index].status}
    />
  );

  const generateHoverContent = (config, show, activateReverseAnimation) => {
    return (
      <>
        {isDesktop && <Mask />}
        <Info2 className={activeStep === 1 ? 'display-none' : 'block'} show={show} activateReverseAnimation={activateReverseAnimation} stepLength={stepConfig.length} flowName={flowName}>
          {!isDesktop && <MobileHoverHeading>{config.description}</MobileHoverHeading>}
          <InfoView>
            {config.stepContent()}
            <CloseTag onClick={handleStepMouseLeave}><img src={close} alt="close" /></CloseTag>
          </InfoView>
        </Info2>
      </>
    )
  }

  const generateContentMobile = (config, index) => {
    return (
      <ExchangeStep
        onClick={e => handleStepMouseEnter(e, config.key)}
        key={config.key}
        active={config && config.key === activeStep}
        title={generateTitleNode(config, activeStep)}
        description={config.key === activeStep && generateDescriptionNode(config.description)}
        status={filled[index].status}
      />
    );
  }

  if (!stepConfig.length) return <div>loadingConfig</div>;
  const contentGenerator = isDesktop ? generateContent : generateContentMobile;
  return (
    <StepFlexRow>
      {/* Had to do this due to the crrent structure. 
      Mobile design was not implemented or broken */}
      <div ref={wrapperRef} className={activeStep === 1 ? 'display-none' : 'block'}>
        {!isDesktop && stepConfig.map((config, index) => {
          const { status, hovered, activateReverseAnimation } = filled[index];
          const toBeShown = status === 'finished' && hovered;
          return config.stepContent && generateHoverContent(config, toBeShown, activateReverseAnimation);
        })}
      </div>
      {!hideSteps &&
        <Col ref={stepperRef} lg={{ span: 4 }}>
          <FlowSteps featureCode={featureCode} affixRef={affixRef} disableSteppers={disableSteppers} current={activeStep} stepLength={stepConfig.length} grantAgreement>
            {stepConfig.map((config, index) => contentGenerator(config, index))}
            {snagSection && window.innerWidth > 991 &&
              <SnagSection>
                <SnagHeader>Hit a snag?</SnagHeader>
                <ContactPara>Contact us: <a href="mailto:donorservice@vanguardcharitable.org" target="_top">email</a> or <a href="tel:888-383-4483">phone</a></ContactPara>
              </SnagSection>
            }
          </FlowSteps>
          {snagSection && window.innerWidth < 991 &&
            <SnagSection>
              <SnagHeader>Hit a snag?</SnagHeader>
              <ContactPara>Contact us: <a href="mailto:donorservice@vanguardcharitable.org" target="_top">email</a> or <a href="tel:888-383-4483">phone</a></ContactPara>
            </SnagSection>
          }
        </Col>
      }
      <Col lg={!hideSteps ? { span: 19, offset: 1 } : { span: 24 }}>
        {stepConfig.map(config => {
          return (
            <>
              <Route
                exact
                path={config.route}
                component={config.mainContent}
              />
              {config.subRoutes && config.subRoutes.map(subRoute => <Route {...subRoute} />)}
            </>)
        })}
      </Col>
    </StepFlexRow >
  );
};

GenericStepper.propTypes = {
  affixRef: PropTypes.shape({
    current: PropTypes.shape({
      offsetHeight: PropTypes.any,
      offsetTop: PropTypes.any
    })
  }),
  disableSteppers: PropTypes.any,
  featureCode: PropTypes.string,
  flowName: PropTypes.any,
  grantAgreement: PropTypes.any,
  hideSteps: PropTypes.any,  
  snagSection: PropTypes.bool,
  stepConfig: PropTypes.array
}

export default withRouter(GenericStepper);
